import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {DwtService} from 'src/app/share/services/dwt/dwt.service';

@Component({
    selector: 'app-scan-document',
    templateUrl: './scan-document.component.html',
    styleUrl: './scan-document.component.scss',
    standalone: false
})
export class ScanDocumentComponent implements OnInit {
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>
  eventsSubject: Subject<void> = new Subject<void>();

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.eventsSubject.next(event);
  }
  bStartUp = true;
  bStartDemo = false;
  bUseCameraViaDirectShow = true;
  constructor(protected dwtService: DwtService){
    let _this = this;
    dwtService.showStartDemo(function(bShowStartDemo: any){
      _this.bStartDemo = bShowStartDemo;
   });
  }

  ngOnInit(): void {
    this.bStartUp = !this.bStartUp;
    this.dwtService.bUseCameraViaDirectShow = this.bUseCameraViaDirectShow;
  }
  onCloseIconClick(){
    this.closeEvent.emit();
  }
}
